import React, { useState, useEffect } from "react";
import { Modal, Button } from "components/common";
import { useMutation } from "@apollo/react-hooks";
import TERMINATE_ACCOUNT from "./mutations";
import dropdownArrow from "assets/dropdown-arrow.svg";
import { COMPLETION_STATUS } from "utils/constants";

const TerminationModal = ({ user }) => {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState("Fraud");
  const [otherReason, setOtherReason] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [terminateAccount] = useMutation(TERMINATE_ACCOUNT);

  useEffect(() => {
    setError(false);
    setOtherReason(null);
    setLoading(false);
  }, [showModal]);

  useEffect(() => {
    setConfirm(null);
  }, [reason, otherReason]);

  useEffect(() => {
    setError(false);
    setOtherReason(null);
    setLoading(false);
    if (user.completion_status === COMPLETION_STATUS.TERMINATED) {
      setSuccess(true);
    }
  }, []);

  const handleTermination = async () => {
    setError(false);
    setLoading(true);
    let payload = {
      email: user.email,
      reason: otherReason ? otherReason : reason
    };
    await terminateAccount({ variables: payload })
      .then(response => {
        if (response.data.terminateAccount.status == `OK`) {
          setSuccess(true);
        }
      })
      .catch(err => {
        console.log(err, "error terminating user");
        setError(true);
      });
    setLoading(false);
  };

  return (
    <>
      {showModal && (
        <div className="bg-black" style={{ maxWidth: 500 }}>
          <Modal
            isOpen={showModal}
            close={() => setShowModal(false)}
            hasCrossContainer={false}
          >
            <div className="bg-white">
              <div className="bg-black text-white text-xl py-3 px-3">
                <p>Terminate User</p>
              </div>
              {error ? (
                <div
                  className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mx-2 my-2"
                  role="alert"
                >
                  <strong className="font-bold">Error: </strong>
                  <span className="block sm:inline">
                    Unable to terminate user
                  </span>
                </div>
              ) : success ? (
                <div
                  class="bg-teal-100 border border-teal-500 rounded-b text-teal-900 px-4 py-3 rounded relative mx-2 my-2"
                  role="alert"
                >
                  <strong className="font-bold">Success: </strong>
                  <span className="block sm:inline">
                    User has been terminated
                  </span>
                </div>
              ) : (
                <div
                  className="bg-orange-100 border border-orange-400 text-orange-700 px-4 py-3 rounded relative mx-2 my-2"
                  role="alert"
                >
                  <strong className="font-bold">Warning: </strong>
                  <span className="block sm:inline">
                    User termination is permanent!
                  </span>
                </div>
              )}
              <div className="text-center my-2 mx-2 py-2">
                <p className="font-extralight mx-3 pb-2">
                  <span className="font-bold">USER : </span>
                  {user.email}
                </p>
              </div>
              {!success &&
                user.completion_status !== COMPLETION_STATUS.TERMINATED && (
                  <div className="flex justify-center flex-col items-center content-center mx-auto">
                    <div className="py-3">
                      <p className="font-extralight mb-2">
                        Choose Termination Reason
                      </p>
                      <div className="inline-block relative w-64">
                        <select
                          onChange={(e) => setReason(e.target.value)}
                          required
                          className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:ring"
                        >
                          <option>Fraud</option>
                          <option>Inactive</option>
                          <option>Unauthorized ACH Payment request</option>
                          <option>User requested</option>
                          <option>Other</option>
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <img src={dropdownArrow} className="w-4 h-4" />
                        </div>
                      </div>
                    </div>
                    {reason === "Other" && (
                      <div className="inline-block relative w-64 py-3">
                        <p className="font-extralight mb-2">
                          Specify Other Reason
                        </p>
                        <input
                          className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded px-4 py-2 pr-8 leading-tight focus:outline-none focus:bg-white"
                          id="grid-termination-reason"
                          type="text"
                          required
                          onChange={(e) => setOtherReason(e.target.value)}
                          placeholder="Suspicious Activity"
                        />
                      </div>
                    )}
                    <>
                      <div className="inline-block relative w-64 py-3">
                        <p className="font-extralight mb-2">
                          <span> Confirm Email Address</span>
                        </p>
                        <input
                          className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded px-4 py-2 leading-tight focus:outline-none focus:bg-white"
                          id="grid-termination-confirm"
                          type="text"
                          required
                          placeholder={user.email}
                          onChange={(e) => setConfirm(e.target.value)}
                          value={confirm || ""}
                        />
                      </div>
                    </>
                  </div>
                )}
              {!success && !loading && (
                <div className="mx-auto py-5 px-2  text-center">
                  <Button
                    disabled={
                      !(reason !== "Other"
                        ? confirm === user.email && reason?.length
                        : confirm === user.email &&
                          reason?.length &&
                          otherReason?.length)
                    }
                    onClick={handleTermination}
                  >
                    Submit
                  </Button>
                </div>
              )}
              {loading && (
                <div className="mx-auto py-5 px-2  text-center">
                  <Button disabled onClick={handleTermination}>
                    <i className="fas fa-spinner text-white fa-spin" />
                  </Button>
                </div>
              )}
            </div>
          </Modal>
        </div>
      )}
      <div>
        <button
          type="button"
          onClick={() => setShowModal(!showModal)}
          className="text-green-primary"
        >
          Terminate User
        </button>
      </div>
    </>
  );
};

export default TerminationModal;
